<template>
  <div class="home">
    <z-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="refresh">
        <section>
          <div class="header">账号检测</div>
          <z-row gutter="20" class="needmb">
            <z-col span="12">
              <div class="box" @click="toDetial(0, data.accountStatus.accountStatusMsg)">
                <div class="status">
                  <span>账号状态</span><z-icon name="arrow" size="14px" color="#999999" />
                </div>
                <div class="container" :class="'status' + data.accountStatus.type">
                  <b>{{ data.accountStatus.accountStatusMsg }}</b>
                </div>
              </div>
            </z-col>
            <z-col span="12">
              <div class="box" @click="toDetial(1, data.functionStatus.functionStatusMsg)">
                <div class="status">
                  <span>功能状态</span><z-icon name="arrow" size="14px" color="#999999" />
                </div>
                <div class="container" :class="'status' + data.functionStatus.type">
                  <b>{{ data.functionStatus.functionStatusMsg }}</b>
                </div>
              </div>
            </z-col>
          </z-row>

          <z-row gutter="20">
            <z-col span="12">
              <div class="box" @click="toDetial(2, data.productStatus.productStatusMsg)">
                <div class="status">
                  <span>商品状态</span><z-icon name="arrow" size="14px" color="#999999" />
                </div>
                <div class="container" :class="'status' + data.productStatus.type">
                  <b>{{ data.productStatus.productStatusMsg }}</b>
                </div>
              </div>
            </z-col>
            <z-col span="12">
              <div class="box" @click="toDetial(3, data.moneyStatus.moneyStatusMsg)">
                <div class="status">
                  <span>钱款状态</span><z-icon name="arrow" size="14px" color="#999999" />
                </div>
                <div class="container" :class="'status' + data.moneyStatus.type">
                  <b>{{ data.moneyStatus.moneyStatusMsg }}</b>
                </div>
              </div>
            </z-col>
          </z-row>
        </section>
        <section v-if="false">
          <div class="header">放心转-欺诈赔付</div>

          <!-- <div class="pay-money need" v-if="+data.payMoneyObj.receiveStatus === 0">
            <div class="pay-money-word">
              <div class="title"><b>平台订单</b><b>遇欺诈</b><b>立赔付！</b></div>
              <div class="content">转转订单|平台沟通|最高赔付2000元</div>
            </div>
            <z-button type="primary" size="small" @click="tobefore(0)">立即领取</z-button>
          </div> -->

          <div class="need pb">

            <!-- 立即领取 -->
            <div
              class="pay-money"
              :style="{
                backgroundImage: 'url(' + $setPicSize('https://pic6.zhuanstatic.com/zhuanzh/4d21586d-bc79-4068-b813-8b69c4ed9aac.png') + ')',
                marginBottom: '0.43rem'
              }"
              v-if="+data.payMoneyObj.receiveStatus === 0"
            >
              <div class="pay-money-word">
                <div>
                  <div class="title-pro" :style="{color: '#FFFFFF'}"><b>平台订单</b><b>遇欺诈</b><b>立赔付！</b></div>
                  <div class="content" :style="{color: '#FFFFFF'}">转转订单|平台沟通|最高赔付2000元</div>
                </div>
                <z-button btn-class="bottombtn" type="primary" size="small" @click="tobefore(0)"
                  >立即领取</z-button
                >
              </div>
              <!-- <z-image src="n_v201bfb9a7f9f9487aa9cee138419ed69b.png" class="pay-money-image" /> -->
            </div>

            <!-- 申请赔付 -->
            <div
              class="pay-money"
              v-if="+data.payMoneyObj.receiveStatus === 1"
            >
              <div class="pay-money-word">
                <div>
                  <div class="title"><b>放心转</b><b>正在保护你的交易安全</b></div>
                  <div class="content">
                    使用有效期：<span>{{
                      formatTime(data.payMoneyObj.startTime, data.payMoneyObj.endTime)
                    }}</span>
                  </div>
                </div>
                <z-button type="primary" size="small" @click="toPay(2)"
                  >申请赔付</z-button
                >
              </div>
              <z-image :src="$setPicSize('https://pic3.zhuanstatic.com/zhuanzh/cb4ea375-cf39-48be-92ca-31beede9910f.png')" class="pay-money-image" />
            </div>

            <!-- 重新领取 -->
            <div
              class="pay-money"
              :style="{
                  backgroundImage: 'url(' + $setPicSize('https://pic6.zhuanstatic.com/zhuanzh/4d21586d-bc79-4068-b813-8b69c4ed9aac.png') + ')',
                  marginBottom: '0.43rem'
                }"
              v-if="+data.payMoneyObj.receiveStatus === 2"
            >
              <div class="pay-money-word">
                <div>
                  <div class="title" :style="{color: '#FFFFFF'}"><b>放心转</b><b>赔付保障已失效</b></div>
                  <div class="content" :style="{color: '#FFFFFF'}">
                    使用有效期：<span>{{
                      formatTime(data.payMoneyObj.startTime, data.payMoneyObj.endTime)
                    }}</span>
                  </div>
                </div>
                <z-button btn-class="bottombtn" type="primary" size="small" @click="tobefore(3)"
                  >重新领取</z-button
                >
              </div>
              <!-- <z-image
                src="https://pic2.zhuanstatic.com/zhuanzh/n_v274dc298342e548b6bcad0417d184df7a.png?w=1800&qa=100"
                class="pay-money-image"
              /> -->
            </div>

            <div class="operate">
              <div class="operate-item" @click="toPay(4)">
                <z-image
                  fit="cover"
                  class="operate-item-image"
                  :src="$setPicSize('n_v28b4f6bdf6e554f1e959a45208099b927.png')"
                />
                <!-- <z-icon name="n_v28b4f6bdf6e554f1e959a45208099b927.png" size="14px"/> -->
                <span>防骗测试</span>
                <!-- <z-icon name="arrow" size="14px"/> -->
              </div>

              <div class="operate-item" @click="toPay(1)">
                <z-image
                  fit="cover"
                  class="operate-item-image"
                  :src="$setPicSize('n_v276825d1b00ec40eb84d818128280dd15.png')"
                />
                <!-- <z-icon name="n_v276825d1b00ec40eb84d818128280dd15.png" size="14px"/> -->
                <span>赔付说明</span>
                <!-- <z-icon name="arrow" size="14px"/> -->
              </div>

              <div class="operate-item" @click="toPay(3)">
                <z-image
                  fit="cover"
                  class="operate-item-image"
                  :src="$setPicSize('n_v29529236e18724b21ae88cf84bc066fab.png')"
                />
                <!-- <z-icon name="n_v29529236e18724b21ae88cf84bc066fab.png" size="14px"/> -->
                <span>我的记录</span>
                <!-- <z-icon name="arrow" size="14px"/> -->
              </div>
            </div>

          </div>
        </section>
        <section v-if="false && data.videoList.length > 0">
          <div class="header">
            防骗指南
            <div class="moreinfo" @click="toVideo()">
              查看更多<z-icon name="arrow" size="14px" />
            </div>
          </div>
          <div class="video">
            <video-player :videoList="data.videoList.slice(0,5)"/>
          </div>
        </section>
        <section v-if="false">
          <div class="header">
            平台规则
            <div class="moreinfo" @click="toMore(1)">
              查看更多<z-icon name="arrow" size="14px" />
            </div>
          </div>
          <div class="article">
            <div
              class="title"
              :class="'title' + idx"
              v-for="(item, idx) in data.platRuleList"
              :key="idx"
              @click="goToArticle(item.linkUrl, 1, item.title)"
            >
              {{ idx + 1 }}、{{ item.title }}
            </div>
          </div>
        </section>

        <section v-if="false">
          <div class="header">
            安全知识
            <div class="moreinfo" @click="toMore(2)">
              查看更多<z-icon name="arrow" size="14px" />
            </div>
          </div>
          <div class="article">
            <div
              class="title"
              :class="'title' + idx"
              v-for="(item, idx) in data.securityKnowledgeList"
              :key="idx"
              @click="goToArticle(item.linkUrl, 2, item.title)"
            >
              {{ idx + 1 }}、{{ item.title }}
            </div>
          </div>
        </section>
      </div>
    </z-pull-refresh>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Row, Col, Icon, Button, PullRefresh, Image } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import setPicSize from '@zz-app/setPicSize'

import VideoPlayer from './VideoPlayer'
import { getSecurityCenter } from '../../../api/resourceApi'
import { queryParams } from '../../../lib/utils'

const query = queryParams()
const linkObj = {
  1: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
  2: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneySelect&applySource=securitycenter',
  3: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyHistory',
  4: 'https://feentry.zhuanzhuan.com/spam?clientid=newSpamQua&source=12'
}
const banner = {
  对号: 'n_v2a44f1b987dc645bdba453448c9bae969.png',
  叹号: 'n_v274dc298342e548b6bcad0417d184df7a.png',
  搜索: 'n_v27b1ba40c6b0445f4b79337916f670d35.png',
  正常: 'cb4ea375-cf39-48be-92ca-31beede9910f.png'
}
export default {
  name: 'SafeCenterHome',
  data() {
    return {
      isLoading: false,
      linkObj,
      data: {
        accountStatus: {}, //帐号状态
        functionStatus: {}, //功能状态
        productStatus: {}, //商品状态
        moneyStatus: {}, //钱款状态
        platRuleList: [], //平台规则列表
        securityKnowledge: [], //安全知识列表
        banner,
        payMoneyObj: {
          receiveStatus: '2', //0:未领取|1:已领取（生效中）|2:已领取（过期）
          endTime: '',
          startTime: ''
        },
        videoList: []
      }
    }
  },
  components: {
    zPullRefresh: PullRefresh,
    zRow: Row,
    zCol: Col,
    zIcon: Icon,
    zButton: Button,
    zImage: Image,
    VideoPlayer
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 600, 600)
    },
    onRefresh() {
      this.getSecurityCenterData(true)
    },
    toMore(form) {
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_HOME',
        actiontype: 'ARTICLE_CLICK',
        backup: {
          form //1 平台规则 2 安全知识
        }
      })
      const link = `https://feentry.zhuanzhuan.com/SafeCenter?clientid=SafeCenterArticle&articleForm=${form}`
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: link
        })
      }, 300)
      // this.$router.push({
      //   path: 'ArticleList',
      //   query: { articleForm: form }
      // })
    },
    tobefore(receiveSource) {
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyBeforeQuestion&receiveSource=${receiveSource}`
        })
      }, 300)
    },
    toVideo() {
      this.$router.push({
        path: 'VideoList',
        query: {
          videoList: this.data.videoList
        }
      })
    },
    toPay(value) {
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_HOME',
        actiontype: 'PAYMONEY_CLICK',
        backup: {
          form: value || 'unknow' //1 赔付说明 3我的记录 4 防骗测试
        }
      })
      const targetUrl = linkObj[value]
      setTimeout(() => {
        native.skipToUrl({
          targetUrl
        })
      }, 300)
      console.log('value', value)
    },
    toDetial(active, statusMsg) {
      const link = `https://feentry.zhuanzhuan.com/SafeCenter?clientid=SafeCenterDetial&active=${active}`
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_HOME',
        actiontype: 'DETIAL_CLICK',
        backup: {
          active,
          statusMsg
        }
      })
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: link
        })
      }, 300)
      // setTimeout(() => {
      //   this.$router.push({
      //     path: 'detial',
      //     query: { active }
      //   })
      // }, 500);
    },
    async getSecurityCenterData() {
      const res = await getSecurityCenter({})
      this.isLoading = false
      console.log('res', res)
      this.data = { ...this.data, ...res }
    },
    goToArticle(link, form, title) {
      console.log('link', link)
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_HOME',
        actiontype: 'FAST_ARTICLE_CLICK',
        backup: { form }
      })
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_HOME',
        actiontype: 'ARTICLE_CLICK',
        backup: { form, title }
      })
      if (!link) return ''
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: link
          // needClose: '1'
        })
      }, 300)
    },
    handleVisiable(e) {
      if (e.target.visibilityState === 'visible') {
        console.log('我回首页了')
        this.getSecurityCenterData()
      }
    },
    formatTime(start, end) {
      return this.transTime(start) + ' - ' + this.transTime(end)
    },
    transTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY.MM.DD') : ''
    }
  },
  mounted() {
    native.setTitle({
      title: '安全中心'
    })
    this.getSecurityCenterData()
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  beforeRouteEnter(to, from, next) {
    console.log('Home to', to)
    console.log('Home from', from)
    console.log('query form', query.form)
    if (from.path === '/') {
      //从其他页面跳转进来
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_HOME',
        actiontype: 'ARTICLE_CLICK',
        backup: {
          form: query.form || 'unknow' // 页面来源 有 myapp -我的App
        }
      })
    }
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
